import React, { useEffect, useRef, useState } from 'react'
import Chart from 'react-apexcharts'
import objectPath from 'object-path'

import { getLegend } from 'designer/component/system/menu/virtualization/setting/apexcharts/legend/formatter'
import { getDataLabels } from 'designer/component/system/menu/virtualization/setting/apexcharts/dataLabels/formatter'
import { getTooltip } from 'designer/component/system/menu/virtualization/setting/apexcharts/tooltip/formatter'
import { getTotal } from 'designer/component/system/menu/virtualization/setting/apexcharts/total/formatter'

const ApexChartsSample = ({
  chart,
  renderChart = true,
  height,
  dashboardKey,
}) => {
  const { series = {}, options = {}, properties = {} } = chart
  const chartRef = useRef()
  const chartKey = chart?.chartKey

  const [state, setState] = useState({
    chart: chart?.chart,
    series: series,
    options: options,
  })
  const [firstRender, setFirstRender] = useState(true)

  useEffect(() => {
    if (renderChart && chartRef?.current?.chartRef?.current) {
      if (options?.categories) {
        objectPath.set(options, 'xaxis.categories', options?.categories)
        objectPath.set(options, 'xaxis.convertedCatToNumeric', false)
      }

      let legend = getLegend(chartKey, properties)
      if (legend) {
        objectPath.set(options, legend?.formatterKey, legend?.formatter)
      }

      let dataLabels = getDataLabels(chartKey, properties)
      if (dataLabels) {
        objectPath.set(options, dataLabels?.formatterKey, dataLabels?.formatter)
      }

      let tooltips = getTooltip(chartKey)
      if (tooltips) {
        tooltips.forEach((tooltip) => {
          objectPath.set(options, tooltip?.formatterKey, tooltip?.formatter)
        })
      }
      let totals = getTotal(chartKey, properties)
      if (totals) {
        totals.forEach((total) => {
          objectPath.set(options, total?.formatterKey, total?.formatter)
        })
      }
      objectPath.set(state, 'options', options)
      setState(state)
    }
  }, [renderChart])

  useEffect(() => {
    setFirstRender(false)
  }, [dashboardKey])

  return (
    <div
      className="d-flex justify-content-center mt-4"
      style={{
        opacity: firstRender ? '0' : '100%',
        transition: 'all .5s ease-in-out',
      }}
    >
      <Chart
        id={dashboardKey}
        {...state}
        type={state.chart.type}
        height={height || state.chart.height}
        className="w-100 d-flex"
        ref={chartRef}
      />
    </div>
  )
}

export default ApexChartsSample
